{
  "slug": "what-is-the-average-iq",
  "title": "ما هو متوسط معدل الذكاء؟",
  "description": "لاحظ لماذا متوسط معدل الذكاء عادة ما يكون 100)١( انظر الوثيقة A/CONF.157/24 (Part I)، الفصل الثاني، الفرع ألف.",
  "summary": "على معظم مستويات الذكاء الحديثة، يحدد المتوسط على 100ويقع نحو ثلثي السكان المرجعيين بين سن 15 و 24 عاما. 85 و 115.",
  "sections": [
    {
      "heading": "لماذا المتوسط هو 100",
      "paragraphs": [
        "إن مقاييس الذكاء موحدة وليس لها عدد ثابت من الإجابات الصحيحة. ويحول الناشرون النتائج الخام بحيث يصبح متوسط المجموعة المرجعية 100.10010- ويعاد تنظيم الاختبارات دورياً مع تغير السكان والخبرات التعليمية.",
        "نقطة قريبة من. 100 يعني الأداء قريبا من منتصف المجموعة المعيارية المختارة - ليس أن شخصا ما أجاب. 100 أو يملك كمية محددة من المعلومات الاستخبارية."
      ]
    },
    {
      "heading": "المادة المشتركة 85–115 النطاق",
      "paragraphs": [
        "مع انحراف معياري قدره 15, حوالي 68النسبة المئوية للتوزيع الطبيعي تقع بين 85 إلى 115)و( 95النسبة المئوية من 70 إلى 13010- هذه الأرقام تقريبية.",
        "ويمكن أن تكون المئويات أسهل فهماً: 100 قريبة من 50المئين الثانى، 115 بالقرب من 841 - 2002، و 2003 85 بالقرب من 16« طاء » الله أعلم بمراده بذلك."
      ]
    },
    {
      "heading": "استخدام المقارنات بعناية",
      "paragraphs": [
        "10- إن الدرجة تحتاج إلى معايير عمرية مناسبة وإلى نسخة حديثة من الاختبار. واللغة والتعليم والصحة والسياق أمور مهمة. والمقارنات بين البلدان أو بين السكان حساسة بشكل خاص فيما يتعلق بأخذ العينات والمنهجية.",
        "وبالنسبة للفرد، فإن فترات الثقة وبيانات الاختبار الفرعي أكثر فائدة من معاملة المجموع على أنه دقيق تماما."
      ]
    }
  ],
  "faqs": [
    {
      "question": "يس 100 معدل ذكاء جيد؟",
      "answer": "20 نقطة 100 يقع في مركز المجموعة المعيارية ويمثل الأداء النموذجي على القدرات التي تم تقييمها."
    },
    {
      "question": "ما هي النسبة المئوية للأشخاص الذين يحصلون على أعلى 100?",
      "answer": "أعلى من نصف الدرجة تقريبا 100 )٢( انظر الشكل ٤-١."
    }
  ],
  "related": ["iq-score-ranges-explained", "what-does-an-iq-of-120-mean", "how-is-iq-measured"]
}
